import { useEffect } from "react";

import Typography from "@mui/material/Typography";
import {ReactComponent as ArrowBackIosIcon} from "../icons/ArrowBackIos24.svg";
import IconButton from "@mui/material/IconButton";
import { useNavigate } from "react-router-dom";

const Title = ({ text, showBack = false, onBack = null }) => {
  const navigate = useNavigate();

  useEffect(() => {
  }, []);


  const handleGoBack = () => {
    if (onBack != null) {
      onBack();
      return;
    }

    navigate(-1);
  }

  return (
    <>
      <Typography variant="h5" component="h2" sx={{ mt: 1,fontFamily:"arial", fontWeight:"700" }} className="noprint" data-testid="ttlHead">
        {showBack === true && (
          <IconButton
          variant="contained"
            size="large"
            aria-label="go back"
            onClick={handleGoBack}
            color="primary"
            sx={{pt:1, pr:0.0}}
          >
            <ArrowBackIosIcon  />
          </IconButton>
        )}
        {text}
      </Typography>
    </>
  );
};

export default Title;
